type EnabledAnchorsParams = {
  x: number;
  y: number;
  width: number;
  height: number;
  canvasWidth: number;
  canvasHeight: number;
};

// Anchors on a side flush against the canvas edge are hidden (JS-1248): they
// sit half outside the stage and offer no room to grow. A corner anchor goes
// with either of its sides. An object covering the whole canvas keeps all
// anchors — hiding them all would make it impossible to ever shrink it.
export const getEnabledAnchors = ({
  x,
  y,
  width,
  height,
  canvasWidth,
  canvasHeight,
}: EnabledAnchorsParams): string[] => {
  const touchesLeft = x <= 0;
  const touchesTop = y <= 0;
  const touchesRight = x + width >= canvasWidth;
  const touchesBottom = y + height >= canvasHeight;

  const anchors = [
    ...(!touchesTop && !touchesLeft ? ['top-left'] : []),
    ...(!touchesTop && !touchesRight ? ['top-right'] : []),
    ...(!touchesBottom && !touchesLeft ? ['bottom-left'] : []),
    ...(!touchesBottom && !touchesRight ? ['bottom-right'] : []),
    ...(!touchesLeft ? ['middle-left'] : []),
    ...(!touchesRight ? ['middle-right'] : []),
    ...(!touchesTop ? ['top-center'] : []),
    ...(!touchesBottom ? ['bottom-center'] : []),
  ];

  if (anchors.length === 0) {
    return [
      'top-left',
      'top-right',
      'bottom-left',
      'bottom-right',
      'middle-left',
      'middle-right',
      'top-center',
      'bottom-center',
    ];
  }

  return anchors;
};
